import React, { useEffect, useState } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import {
  FormInput,
  FormSelect,
  CustomSearchableSelect,
} from "../../../Components/Forms/InputTemplate";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { FiPlus } from "react-icons/fi";
import { BsDash } from "react-icons/bs";
import { PROCUREMENT_TYPE } from "../../../../../utils/Enums";
import { useHrGetQuery } from "../../../../api/hrApi";

function RequisitionBeneficiaries({ assetItems }) {
  const formMethods = useFormContext();
  const fieldArray = useFieldArray({
    control: formMethods.control,
    name: "beneficiaries",
  });
  const { fields, append, remove } = fieldArray;

  const { departments } = useSelector((x) => x?.procurement);

  const { data: employees } = useHrGetQuery(
    `/Employee/GetAllEmployees?ApprovalStatus=0&PageSize=100000&PageNumber=1`
  );

  const { data: bracn } = useHrGetQuery(
    `/Container/AllContainer?TypeOfContainer=2&PageSize=100&PageNumber=1&`
  );
  let all_branches = bracn?.responseObject?.pageItems;
  return (
    <>
      {assetItems?.category?.toLowerCase() !==
        PROCUREMENT_TYPE.Consummable_Type?.Goods && (
        <section className={DashboardStyle.form_section}>
          <h4 className={DashboardStyle.form_section_title}>
            Beneficiary <br /> Information
          </h4>
          <div className={DashboardStyle.inputs_group}>
            {fields?.map((x, index) => {
              const fieldName = `beneficiaries.[${index}]`;
              return (
                <fieldset
                  className={DashboardStyle.inputs_group}
                  name={fieldName}
                  key={fieldName}
                  style={{
                    border: "none",
                    borderTop: "1px solid #d9e9d9",
                    paddingTop: "1rem",
                  }}
                >
                  <FieldInputs
                    append={() => append()}
                    remove={(index) => remove(index)}
                    index={index}
                    fieldName={fieldName}
                    beneficiaries={employees}
                    departments={departments}
                    branches={all_branches}
                  />
                </fieldset>
              );
            })}
          </div>
        </section>
      )}
    </>
  );
}

export default RequisitionBeneficiaries;

function FieldInputs({
  fieldName,
  beneficiaries,
  departments,
  remove,
  index,
  append,
  branches,
}) {
  console.log("beneficiaries", beneficiaries);
  const sortedBeneficiaries =
    beneficiaries &&
    beneficiaries?.result
      ?.slice()
      .sort((a, b) => a.firstName.localeCompare(b.firstName));

  console.log("sortedBeneficiaries", sortedBeneficiaries);

  const { setValue, getValues, watch } = useFormContext();
  const [flip, setFlip] = useState(
    getValues(`${fieldName}.beneficiaryType`)?.toString() || ""
  );
  // State to hold the selected department ID
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);
  useEffect(() => {
    setValue(
      `${fieldName}.branch`,
      branches?.find((x) => x?.id === +watch(`${fieldName}.branchId`))?.name
    );

    setValue(
      `${fieldName}.department`,
      departments?.responseObject?.pageItems?.find(
        (x) => x?.id === +watch(`${fieldName}.departmentId`)
      )?.name
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch(`${fieldName}.departmentId`), watch(`${fieldName}.branchId`)]);

  return (
    <>
      <div>
        <FormSelect
          title={"Beneficiary Type"}
          camelCase={`${fieldName}.beneficiaryType`}
          placeholder={"select"}
          array={
            <>
              <option value="0">Individual</option>
              <option value="1">Department</option>
            </>
          }
          moreRegister={{
            onChange: (e) => {
              setValue(`${fieldName}.department`, "");
              setValue(`${fieldName}.branch`, "");
              return setFlip(e.target.value);
            },
          }}
        />

        {(flip === "0" || flip === "1") && (
          <FormSelect
            title={"Department"}
            camelCase={`${fieldName}.departmentId`}
            placeholder={"select"}
            array={departments?.responseObject?.pageItems?.map?.((x, index) => (
              <option key={index} value={x?.id}>
                {x?.name}
              </option>
            ))}
            moreRegister={{
              onChange: (e) => {
                setSelectedDepartmentId(e.target.value);
                // setValue(`${fieldName}.beneficiaryName`, "");
                setValue(`${fieldName}.beneficiaryName`, "");
                // Clear the selected text
                // document.getElementById(`${fieldName}.beneficiaryName`).selectedIndex = -1;
              },
            }}
          />
        )}

        {/* 
        {flip === "0" && (
          <FormSelect
            title={"Department"}
            camelCase={`${fieldName}.departmentId`}
            placeholder={"select"}
            isOptional={true}
            array={departments?.responseObject?.pageItems?.map?.((x, index) => (
              <option key={index} value={x?.id}>
                {x?.name}
              </option>
            ))}
          />
        )} */}

        {(flip === "0" || flip === "1") && (
          //           <CustomSearchableSelect
          //             title={"Beneficiary Name"}
          //             camelCase={`${fieldName}.beneficiaryName`}
          //             placeholder={"select"}
          //             options={beneficiaries?.result?.filter((x)=> x.departmentId==selectedDepartmentId).map?.((x, index) => ({
          //               object:x,
          //               value: x?.firstName +' '+x?.surname, // Replace 'value' with the actual property name containing the value
          //               label: x?.firstName +' '+x?.surname, // Replace 'label' with the actual property name containing the label
          //             }))}
          //             moreRegister={{
          //               onChange: (e) => {
          // const dat = e?.value
          //                 //  const isFound = beneficiaries?.result.find(
          //                 //   (x) => e?.value == `${x?.userId}`
          //                 // );

          //                 const isFound = beneficiaries?.result.find(
          //                   (x) => dat?.includes(x?.firstName) && value.includes(x?.surname)
          //                 );

          //                 console.log('isFound,',isFound);

          //              //   console.log('eeee,'+ fieldName,e);

          //                 // console.log('isFound,',isFound);
          //                 // return (
          //                 //   setValue(`${fieldName}.departmentId`, isFound?.departmentId)

          //                 // );
          //               },
          //             }}
          //           />

          <CustomSearchableSelect
            title={"Beneficiary Name"}
            camelCase={`${fieldName}.beneficiaryName`}
            placeholder={"select"}
            options={(selectedDepartmentId
              ? sortedBeneficiaries?.filter(
                  (x) => x.departmentId === selectedDepartmentId
                )
              : sortedBeneficiaries
            )?.map((x) => ({
              object: x,
              value: x?.firstName + " " + x?.surname, // Full name as the value
              label: x?.firstName + " " + x?.surname + " " + x?.agentCode, // Full name as the label
            }))}
            moreRegister={{
              onChange: (e) => {
                const dat = e?.value;

                const isFound = sortedBeneficiaries?.find(
                  (x) => dat?.includes(x?.firstName) && dat.includes(x?.surname)
                );

                // console.log("isFound:", isFound);

                if (isFound) {
                  setValue(`${fieldName}.departmentId`, isFound?.departmentId);
                }
              },
            }}
          />
        )}
        {/* {flip === "2" && (
          <FormSelect
            title={"Branch"}
            camelCase={`${fieldName}.branchId`}
            placeholder={"select"}
            array={branches?.map((x) => (
              <option value={x?.id}>{x?.name}</option>
            ))}
          />
        )} */}
        {flip === "2" && (
          <FormSelect
            title={"Branch"}
            camelCase={`${fieldName}.branchId`}
            placeholder={"select"}
            isOptional={true}
            // disabled={true}
            array={branches?.map((x) => (
              <option value={x?.id}>{x?.name}</option>
            ))}
          />
        )}

        <FormInput
          title={`Quantity`}
          camelCase={`${fieldName}.quantity`}
          placeholder={"Enter Quantity"}
        />
      </div>
      {index !== 0 ? (
        <div
          style={{
            color: "#E61B00",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            gap: "5px",
            marginTop: "1rem",
          }}
          onClick={() => remove?.(index)}
        >
          <BsDash />

          <p>Remove Setup</p>
        </div>
      ) : (
        <div
          style={{
            color: "var(--primary-color)",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            gap: "5px",
            marginTop: "1rem",
          }}
          onClick={() => append?.({})}
        >
          <FiPlus />
          <p>Add Another</p>
        </div>
      )}
    </>
  );
}
